import { ArrowForwardIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { ShareTriggerButton } from './ShareEvent.styles';

interface ShareButtonProps {
  onClick?: () => void;
  isLabelHidden?: boolean;
}

const ShareEventButton = ({
  onClick,
  isLabelHidden = false,
}: ShareButtonProps) => {
  return (
    <ShareTriggerButton onClick={onClick} dataName="share-event-button">
      <ArrowForwardIcon color="secondaryText" height={12} />
      {!isLabelHidden && (
        <Text
          size="xsmall"
          inline
          ml="4px"
          color="secondaryText"
          lineHeight="normal"
        >
          Share
        </Text>
      )}
    </ShareTriggerButton>
  );
};

export default ShareEventButton;
